import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class AgendaAtividadeValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        
        if (refs.idErpInput.required && isNull(model.idtipoagendaatividadeerp)) {
			refs.idErpInput.focusedOut = true;
			validated = false;
		}

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}